import { neutral } from '../../../styles/mui/colors';

export const lineItemStyles = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  m: 0,
  pt: { xs: 0, md: '6px' },
  pb: { xs: 0, md: '2px' },
};

export const bookingPeriodStyles = {
  flex: '1 1',
  display: 'flex',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  pb: { xs: '6px', md: 1 },
};

export const bookingPeriodSectionRightStyles = {
  textAlign: 'right',
};

export const dayLabelContainerStyles = {
  m: 0,
  pt: { xs: '2px', md: '1px' },
  pb: { xs: '4px', md: '7px' },
};

export const subTotalLineItemStyles = {
  m: 0,
  pt: { xs: '5px', md: '6px' },
  pb: { xs: '1px', md: '2px' },
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
};

export const lineItemTotalStyles = {
  m: 0,
  pt: '6px',
  pb: { xs: '8px' },
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-end',
  justifyContent: 'space-between',
};

export const totalDividerStyles = {
  width: '100%',
  bgcolor: neutral[200],
  mt: { xs: '12px', md: '7px' },
  mb: { xs: '5px', md: 0 },
};

export const feeInfoStyles = {
  flexShrink: 0,
  m: 0,
  pb: { xs: '14px', md: '21px' },
};

export const itemValueStyles = {
  ml: '10px',
};
